import React, { useEffect, useState } from "react";
import Link from "next/link";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { AppBar } from "@mui/material";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import { MdOutlineStar } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import dynamic from "next/dynamic";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });
import styles from "./demo_free.module.scss";

const data = [
  {
    id: 1,
    title: "The complete IELTS comprehensive course of learning",
    image: getAssets("assets/images/elearning/home/free_demo.png"),
  },
  {
    id: 2,
    title: "IELTS comprehensive course of learning",
    image: getAssets("assets/images/elearning/home/free_demo3.jpg"),
  },
  {
    id: 3,
    title: "Complete IELTS comprehensive course of learning",
    image: getAssets("assets/images/elearning/home/free_demo2.png"),
  },
  {
    id: 4,
    title: "Complete IELTS course of learning detail learning of IELTS",
    image: getAssets("assets/images/elearning/home/free_demo4.jpg"),
  },
];

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronRight
      className={`${className} ExamFreeDemo InstructionGallerySliderNext`}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronLeft
      className={`${className} ExamFreeDemo InstructionGallerySliderPrev`}
      onClick={onClick}
    />
  );
}

// Material ui related
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#fff",
  },
}));

export const ElearningDemoFree = () => {
  const [isOpenVideo, setOpenVideo] = useState(false);

  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerPadding: "60px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          dots: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const classes = useStyles();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const ExamFreeDemoCard = ({ item, ...props }) => {
    return (
      <div className={styles.exam_free_demo_card}>
        <div className={styles.card_image_wrapper}>
          <img src={item?.image} alt="free demo" />
          <PlayButtonWithRipple medium onClick={() => setOpenVideo(true)} />
        </div>
        <div className={styles.demo_card_body}>
          <Link legacyBehavior href="#">
            <a className={styles.demo_link}>{item?.title}</a>
          </Link>
        </div>
      </div>
    );
  };

  return (
    <>
      <section>
        <div className="container">
          <div className={styles.tab_wrapper}>
            <div className="ExamFreeDemoTabs">
              <div className={classes.root}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable auto tabs example"
                  >
                    <Tab label="IELTS" {...a11yProps(0)} />
                    <Tab label="PTE" {...a11yProps(1)} />
                    <Tab label="GMAT" {...a11yProps(2)} />
                    <Tab label="GRE" {...a11yProps(3)} />
                    <Tab label="TOEFL" {...a11yProps(4)} />
                  </Tabs>
                </AppBar>

                <TabPanel value={value} index={0}>
                  <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} sm={12} md={4}>
                      <div className={styles.heading_wrapper}>
                        <h3 className={styles.heading}>
                          Score a 8+ band score on the International
                          Standardised Test for English Proficiency
                        </h3>
                        <div className={styles.sub_text}>
                          Ipsum quis pulvinar vitae bibendum gravida maecenas
                          fusce etiam. Scelerisque sit nunc, praesent blandit
                          risus. Tortor vulputate nibh.
                        </div>
                      </div>
                      <div className={styles.btn_wrapper}>
                        <Link legacyBehavior href="#">
                          <a className={`btn btn-secondary btn-bg`}>
                            Join for FREE Demo
                          </a>
                        </Link>
                        <Link legacyBehavior href="#">
                          <a className={`btn btn-grey-border btn-bg`}>More</a>
                        </Link>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={8}>
                      <div
                        className={`instructioin-video-slider exam-free-demo-slider`}
                      >
                        <Slider {...settings}>
                          {data.map((item) => (
                            <ExamFreeDemoCard item={item} key={item.id} />
                          ))}
                        </Slider>
                      </div>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  PTE
                </TabPanel>
                <TabPanel value={value} index={2}>
                  GMAT
                </TabPanel>
                <TabPanel value={value} index={3}>
                  GRE
                </TabPanel>
                <TabPanel value={value} index={4}>
                  TOEFL
                </TabPanel>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ModalVideo
        channel="custom"
        autoplay
        isOpen={isOpenVideo}
        url="https://d2ogu7kfbtzzv3.cloudfront.net/files/UniSearch_Finale-1634995602483.mp4"
        onClose={() => setOpenVideo(false)}
      />
    </>
  );
};

export default ElearningDemoFree;
